module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('mu-row', {
    staticClass: "main_nav"
  }, [_c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "10",
      "tablet": "10",
      "desktop": "10"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "size": "65"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-tabs', {
    staticClass: "main_nav",
    attrs: {
      "value": "tab0"
    }
  }, [_vm._l((_vm.modules), function(item, index) {
    return [_c('mu-tab', {
      key: item.pkid,
      attrs: {
        "title": item.name,
        "index": item.pkid,
        "value": _vm.setValue(index)
      },
      on: {
        "click": function($event) {
          return _vm.openNewWindow(item.href)
        }
      }
    })]
  })], 2)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "10",
      "tablet": "10",
      "desktop": "10"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "white",
      "padding": "0 30px",
      "cursor": "default"
    }
  }, [(_vm.userInfo) ? [_c('div', {
    staticClass: "user-detail"
  }, [_c('mu-icon', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "value": "account_circle",
      "size": "36"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "user-name",
    on: {
      "click": function($event) {
        return _vm.openNewWindow(_vm.UserCenterLocation + '#0')
      }
    }
  }, [_vm._v(_vm._s(_vm.username) + "  ")])], 1)] : [_c('div', {
    staticClass: "user-detail"
  }, [_vm._v("登录")])]], 2)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('iframe', {
    attrs: {
      "src": _vm.srcParam,
      "width": "100%",
      "height": "100%",
      "frameborder": "no",
      "border": "0",
      "marginwidth": "0",
      "marginheight": "0",
      "allowtransparency": "yes"
    }
  })]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot",
    staticStyle: {
      "position": "fixed",
      "width": "-webkit-fill-available",
      "bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 rows"
  }, [_c('div', {
    staticClass: "footHrefOuter"
  }, [_c('p', {
    staticClass: "footHref3",
    staticStyle: {
      "background": "rgb(204, 204, 204)",
      "font-size": "12px"
    }
  }, [_c('span', [_vm._v("\n\t\t\t\t\t\t\t版权所有@ 2008-2018 济南市自然资源和规划局 技术支持：北京超图股份有限公司\n\t\t\t\t\t\t")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4b9561a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 533
// module chunks = 1